/* eslint-disable no-console */
/* eslint-disable no-undef */

/**
 * DYNAMIC PUBLIC PATH
 *
 * PublicPath specifies the virtual directory in web server from where bundled file
 * my-bundled-file.js is going to get served up from.
 * So in summary, publicPath is like mapping between virtual directory in your
 * server and output directory specified by output.path configuration,
 * Whenever request for file public/assets/js/app.js comes, /examples/dist/app.js
 * file will be served.
 *
 * We need to override PUBLIC_PATH at runtime. The public path is specified by BE in the
 * HTML template : window.SkyFoundationSettings.staticDomain (hard wired in the template)
 *
 * TODO: Ask to BE and DevOps to avoid this behavior.
 * Make different builds for different environments using process.env.PUBLIC_PATH and
 * webpack specific configuration (output.publicPath) can solve this issue.
 *
 */

const AEM_CLIENT_LIB_NAME = 'dp_liveblog';

const AEM_JS_RESOURCES_PUBLIC_PATH = `sky-aem-frontend-liveblog/clientlibs/${AEM_CLIENT_LIB_NAME}/`; // + js/resources/ added by webpack config (staticFolder)

// @ts-ignore
const AEM_STATIC_FOLDER = window?.SkyFoundationSettings?.staticDomain || undefined;

if (AEM_STATIC_FOLDER) {
  // @ts-ignore
  __webpack_public_path__ = `${AEM_STATIC_FOLDER}${AEM_JS_RESOURCES_PUBLIC_PATH}`; // eslint-disable-line camelcase
  // @ts-ignore
  console.info(`Override default public path __webpack_require__.p to: ${__webpack_require__.p}`);
} else {
  // @ts-ignore
  console.warn(`PUBLIC PATH not found in window , the default public path is: ${__webpack_require__.p}`);
}
